import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../apiHandles/user_authentication";
import "../assets/css/argon-dashboard-react.css";

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row,
    Col,
} from "reactstrap";

const PasswordReset = () => {
    const { uid, token } = useParams();
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword || !confirmPassword) {
            setError("Please fill in all fields");
            return;
        }

        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            setIsLoading(true);
            setError("");

            const res = await resetPassword(uid, token, newPassword);

            if (res && (res.status === 200 || res.status === 201)) {
                setSuccess(true);

                setTimeout(() => {
                    navigate("/auth/login");
                }, 3000);
            }
        } catch (err) {
            console.error("Password reset error:", err);

            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError("Failed to reset password. The link may be invalid or expired.");
            }
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!error) return;
        const timer = setTimeout(() => setError(""), 5000);
        return () => clearTimeout(timer);
    }, [error]);

    if (success) {
        return (
            <div className="loginBack" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
                <Row style={{ width: "100%", margin: 0 }}>
                    <Col xs="12" style={{ display: "flex", justifyContent: "center" }}>
                        <Card style={{
                            maxWidth: "500px",
                            width: "90%",
                            background: "rgba(30, 41, 59, 0.95)",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(148, 163, 184, 0.2)",
                            borderRadius: "24px",
                            padding: "2rem",
                        }}>
                            <CardBody style={{ textAlign: "center" }}>
                                <div style={{
                                    width: "80px",
                                    height: "80px",
                                    background: "rgba(34, 197, 94, 0.1)",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 1.5rem",
                                    border: "3px solid rgba(34, 197, 94, 0.3)",
                                }}>
                                    <i className="ni ni-check-bold" style={{
                                        fontSize: "40px",
                                        color: "#22c55e",
                                    }}></i>
                                </div>
                                <h3 style={{
                                    color: "white",
                                    fontSize: "1.5rem",
                                    fontWeight: "600",
                                    marginBottom: "1rem",
                                }}>
                                    Password Reset Successfully!
                                </h3>
                                <p style={{
                                    color: "#cbd5e1",
                                    fontSize: "0.95rem",
                                    lineHeight: "1.6",
                                }}>
                                    Your password has been changed successfully.
                                    <br />
                                    Redirecting to login...
                                </p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div className="loginBack" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
            <Row style={{ width: "100%", margin: 0 }}>
                <Col xs="12" style={{ display: "flex", justifyContent: "center" }}>
                    <Card className="loginCard" style={{ maxWidth: "500px" }}>
                        <CardHeader style={{
                            background: "transparent",
                            textAlign: "center",
                            paddingTop: "2rem",
                            border: "none",
                        }}>
                            <h2 style={{
                                color: "white",
                                fontSize: "1.75rem",
                                fontWeight: "600",
                                marginBottom: "0.5rem",
                            }}>
                                Create New Password
                            </h2>
                            <p style={{
                                color: "#94a3b8",
                                fontSize: "0.95rem",
                            }}>
                                Enter your new password below
                            </p>
                        </CardHeader>

                        <CardBody style={{ padding: "2rem" }}>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <label className="loginLabel">
                                        New Password
                                    </label>
                                    <InputGroup className="loginInputField">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText className="loginInputText">
                                                <i className="ni ni-lock-circle-open" style={{ fontSize: "18px" }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Enter new password"
                                            type={showPassword ? "text" : "password"}
                                            value={newPassword}
                                            className="custom-input"
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            disabled={isLoading}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                color: "#fff",
                                                fontSize: "1rem",
                                                padding: "16px 12px",
                                                fontWeight: "500",
                                            }}
                                        />

                                    </InputGroup>
                                </FormGroup>

                                <FormGroup>
                                    <label className="loginLabel">
                                        Confirm Password
                                    </label>
                                    <InputGroup className="loginInputField">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText className="loginInputText">
                                                <i className="ni ni-lock-circle-open" style={{ fontSize: "18px" }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Confirm new password"
                                            type={showPassword ? "text" : "password"}
                                            value={confirmPassword}
                                            className="custom-input"
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            disabled={isLoading}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                color: "white",
                                                fontSize: "1rem",
                                                padding: "16px 12px",
                                                fontWeight: "500",
                                            }}
                                        />
                                    </InputGroup>
                                </FormGroup>

                                <div style={{ marginBottom: "1.5rem" }}>
                                    <label style={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "#94a3b8",
                                        fontSize: "0.9rem",
                                        cursor: "pointer",
                                    }}>
                                        <input
                                            type="checkbox"
                                            checked={showPassword}
                                            onChange={() => setShowPassword(!showPassword)}
                                            style={{ marginRight: "8px" }}
                                        />
                                        Show password
                                    </label>
                                </div>

                                {error && (
                                    <div className="loginErrorMsg" style={{ marginBottom: "1rem" }}>
                                        <i className="ni ni-fat-remove" style={{ fontSize: "16px", flexShrink: 0 }}></i>
                                        <span>{error}</span>
                                    </div>
                                )}

                                <Button
                                    type="submit"
                                    disabled={isLoading || !newPassword || !confirmPassword}
                                    className="loginSignInbtn"

                                    style={{
                                        width: "100%",
                                        color: "#fff",
                                        boxShadow: "none"
                                    }}
                                >
                                    {isLoading ? (
                                        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", color: "#fff" }}>
                                            <div style={{
                                                width: "20px",
                                                height: "20px",
                                                border: "3px solid rgba(255, 255, 255, 0.3)",
                                                borderTop: "3px solid white",
                                                borderRadius: "50%",
                                                animation: "spin 1s linear infinite",
                                                color: "#fff"
                                            }}></div>
                                            Resetting Password...
                                        </span>
                                    ) : (
                                        "Reset Password"
                                    )}
                                </Button>
                            </Form>

                            <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
                                <button
                                    onClick={() => navigate("/auth/login")}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "#60a5fa",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                    }}
                                >
                                    ← Back to Login
                                </button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .custom-input::placeholder {
          color: #e8e8e8 !important;
          opacity: 1 !important;
        }
        
        .custom-input::-webkit-input-placeholder {
          color: #e8e8e8 !important;
          opacity: 1 !important;
        }
        
        .custom-input::-moz-placeholder {
          color: #e8e8e8 !important;
          opacity: 1 !important;
        }
        
        .custom-input:-ms-input-placeholder {
          color: #e8e8e8 !important;
          opacity: 1 !important;
        }
      `}</style>
        </div>

    );
};

export default PasswordReset;